import { getApi } from "../base.api";

export const getAllLocations = async () => {
    const response = await getApi('files/companyLocations')
    console.log('Locations response:', response);
    return response;
}